module.exports = __webpack_public_path__ + "img/btn_date.05fe67e1.svg";